// src/utils/loadEmailTemplates.js
import { collection, getDocs, query, where } from "firebase/firestore";

export const loadEmailTemplates = async (db) => {
  const q = query(
    collection(db, "emailTemplates"),
    where("active", "==", true)
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};
